import Vue from "vue";

export const ticket = {
    methods: {

        //TODO: 获取安全确认票
        async getTicket(obj) {
            let { pageSize, pageNum,confirmInfo } = obj;

            let res = await this.$http.get("/tenant/confirm/vote/list", {
                confirmInfo: confirmInfo ?? null,
                pageSize: pageSize,
                pageNum: pageNum,
            });
            return res || [];
        },
        //TODO: 新增安全确认票
        async addTicket(obj) {
            let res = await this.$http.post("/tenant/confirm/vote", obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO:修改安全确认票
        async upTicket(obj) {
            let res = await this.$http.put("/tenant/confirm/vote", obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO:删除安全确认票
        async delTicket(id) {
            let res = await this.$http.delete(`/tenant/confirm/vote/${id}`);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
    },
};
